<template>
    <div class="field left aligned">
        <div class="ui checkbox">
            <input id="logoutAfterReset" type="checkbox" :checked="isLogoutAfterReset" @click="switchType">
            <label for="logoutAfterReset">
              {{$t('common.label.logoutAfterReset')}}
            </label>
        </div>
        <i tabindex="0" :aria-label="$t('common.label.logoutWithPassChgDesc')" id="logoutWithPassChgDesc"
           class="blue small question circle icon link"
           :data-content="$t('common.label.logoutWithPassChgDesc')" data-variation="small"></i>
    </div>
</template>

<script>
export default {
  data: function () {
    return {
      isLogoutAfterReset: false
    }
  },
  mounted: function () {
    $('.icon').popup({
      namespace: 'onhoverpopup',
      hoverable: true,
      delay: {
        show: 300,
        hide: 300
      },
      on: 'hover'
    }).popup({
      namespace: 'onfocuspopup',
      hoverable: true,
      delay: {
        show: 300,
        hide: 300
      },
      on: 'focus'
    })
  },
  methods: {
    switchType: function () {
      this.isLogoutAfterReset = !this.isLogoutAfterReset
      this.$emit('change', this.isLogoutAfterReset)
    }
  }
}
</script>

<style scoped>
    #logoutWithPassChgDesc {
      margin-left: 3px;
    }
</style>
